import React from 'react';
import ErrorMessage from 'shared/templates/ErrorMessage';

const GridErrorMessage = ({ name, error }) => {
  const message = `Problem loading${name ? ` ${name}` : ''} grid. Please try again`;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '1em' }}>
      <ErrorMessage message={message} error={error} />
    </div>
  );
};

export default GridErrorMessage;
